import React, { useRef } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Row, Col, Divider, Button } from "antd"
import { PrinterOutlined } from "@ant-design/icons"
import { Container } from "react-bootstrap"
import Title from "antd/es/typography/Title"
import Navbar from "../../components/Navbar/Navbar"
import logo from "../../assets/images/logo.png"
import {
  capitalizeEachWord,
  formatDate,
  formatStrings,
} from "../../utils/Common"
import ReactToPrint from "react-to-print"

export default function ViewAnnouncement() {
  const location = useLocation()
  const navigate = useNavigate()
  const componentRef = useRef()
  const passedData = location.state || {}

  return (
    <Navbar isForm>
      <Container className="p-4 view-page">
        <div ref={componentRef}>
          <Row gutter={[10, 10]}>
            <Col xs={2} className="me-5">
              <img src={logo} alt="logo" style={{ width: 100 }} />
            </Col>
            <Col xs={20}>
              <Row>
                <Title level={3}>{window.$company_name}</Title>
              </Row>
              <Row>{window.$company_address}</Row>
            </Col>
          </Row>
          <Divider />
          <Row className="center my-3">
            <Title level={4}>ANNOUNCEMENT NO. {passedData?.code || ""}</Title>
          </Row>
          <Row>
            <Col xs={3}>Date</Col>
            <Col xs={1}>:</Col>
            <Col>
              {passedData.announcement_date
                ? formatDate(passedData.announcement_date)
                : ""}
            </Col>
          </Row>
          <Row>
            <Col xs={3}>To</Col>
            <Col xs={1}>:</Col>
            <Col>
              {(function () {
                let to = Array.isArray(passedData.details)
                  ? passedData.details.map((t) =>
                      t?.announcement_to_id === "0" && t?.type === "employees"
                        ? "All Employees"
                        : t?.announcement_to || t
                    )
                  : []
                return to.join(", ")
              })()}
            </Col>
          </Row>
          <Row>
            <Col xs={3}>From</Col>
            <Col xs={1}>:</Col>
            <Col>
              {passedData.announcement_from
                ? capitalizeEachWord(passedData.announcement_from)
                : ""}
            </Col>
          </Row>
          <Row>
            <Col xs={3}>Subject</Col>
            <Col xs={1}>:</Col>
            <Col>
              {passedData.subject ? capitalizeEachWord(passedData.subject) : ""}
            </Col>
          </Row>
          <Divider />
          <Row className="px-5 py-2 center">
            <div
              dangerouslySetInnerHTML={{
                __html: passedData.content ? passedData.content : "",
              }}
            />
          </Row>

          <Row className="mt-5">Prepared by:</Row>
          <Col xs={24} sm={7} className="text-center mt-5">
            {passedData.added_by_name}
            <Divider className="black-divider" />
            <Row className="d-flex justify-content-center">
              {formatStrings(passedData.position)}
            </Row>
          </Col>

          <Row className="mt-5">Approved by:</Row>
          <Col xs={24} sm={7} className="text-center mt-5">
            <Divider className="black-divider" />
            Operations Head
          </Col>
        </div>

        <Row className="d-flex justify-content-end noPrint mt-5">
          <Row>
            <Button
              className="cancel-btn me-2"
              onClick={() => navigate("/announcements")}
            >
              Cancel
            </Button>
            <ReactToPrint
              trigger={() => (
                <Button type="primary">
                  <PrinterOutlined /> Print
                </Button>
              )}
              content={() => componentRef.current}
            />
          </Row>
        </Row>
      </Container>
    </Navbar>
  )
}
